document.body.addEventListener("CPB_ON_PRODUCT_MOUNTED", function (event) {
  console.log("%cCPB is loaded", "color: #1e82dd; font-size: 18px");
  customJS.init();
});

document.addEventListener("click", function (e) {
  if (e.target && e.target.classList.contains("personalize-it--js")) {
    window.dispatchEvent(new Event("resize"));
  }
});

const customJS = {
  init: function () {
    this.initGlobals();
    this.onReactInputFieldEvent();
    this.formatPrice();
    this.reInit();
  },
  initGlobals: function () {
    window.dispatchEvent(new Event("resize"));
  },
  onReactInputFieldEvent: function () {
    const input = document.getElementsByClassName("cpb-quantity-value");
    const qtyBtn = document.getElementsByClassName("cpb-quantity-button");
    const event = new Event("on:customChange", { bubbles: true });
    event.simulated = true;
    qtyBtn.forEach((btn) => {
      btn.addEventListener("click", function (e) {
        const targetInput = btn
          .closest(".cpb-quantity-actions")
          .querySelector(".cpb-quantity-value");
        targetInput.dispatchEvent(event);
      });
    });
    input.forEach((i) => {
      i.addEventListener("change", function (e) {
        setTimeout(() => {
          customJS.formatPrice();
        }, 100);
      });
      i.addEventListener("on:customChange", function (e) {
        setTimeout(() => {
          customJS.formatPrice();
        }, 1100);
      });
    });
  },
  formatPrice: function () {
    const priceEl = document.querySelectorAll(".cpb-product-price");
    const price = window.CPB.getStore().getState().Product.price;
    const currencyCode = Shopify.currency.active || null;
    const newPrice = formatRawPrice(price);

    priceEl.forEach((item) => {
      item.innerHTML = "";
      item.appendChild(document.createTextNode(newPrice));
    });

    function formatRawPrice(price) {
      // Replace commas with dots and convert to a number
      const numericPrice = Number(String(price).replace(",", "."));

      // Check if the conversion is successful and is a finite number
      if (isNaN(numericPrice) || !isFinite(numericPrice)) {
        console.error("Invalid price input");
        return null;
      }

      // Return the formatted price with two decimal places
      return `${Shopify.formatMoney(numericPrice.toFixed(2))} ${currencyCode}`;
    }
  },
  reInit: function () {
    document.body.addEventListener(
      "CPB_ON_OPTIONS_UPDATE",
      function (event) {
        this.formatPrice();
      }.bind(this)
    );
  },
};
